import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  Avatar,
  DarkThemeToggle,
  Dropdown,
  DropdownHeader,
  DropdownItem,
  Navbar,
  NavbarBrand,
} from "flowbite-react";
import { logout } from "../../redux/slices/auth";
import { logo } from "../../images";

const AdminNavBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const handleLogoutButtonClicked = async () => {
    try {
      const resultAction = await dispatch(logout());
      if (logout.fulfilled.match(resultAction)) {
        navigate("/login");
      }
    } catch (error) {}
  };

  const domainUrl = `${window.location.protocol}//${window.location.host}`;

  return (
    <Navbar
      fluid
      className="border-b border-grey-500 bg-white border-b border-gray-200 px-4 py-2.5 dark:bg-gray-800 dark:border-gray-700 fixed left-0 right-0 top-0 z-50"
    >
      <Link to={`${domainUrl}`}>
        <NavbarBrand>
          <img src={logo} className="mr-3 h-6 sm:h-9" alt="Purplebook Logo" />
          <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">
            PurplebookNG
          </span>
        </NavbarBrand>
      </Link>

      <div className="flex md:order-2">
        <h3 className="flex items-center dark:text-white m-2">
          Welcome, {user && user.fullName.split(" ").slice(0, -1).join(" ")}
        </h3>
        <DarkThemeToggle className="mr-2" />
        <Dropdown
          arrowIcon={false}
          inline
          label={
            <Avatar
              alt="User settings"
              img={user && user.profileImage}
              rounded
            />
          }
        >
          <DropdownHeader>
            <span className="block text-sm">{user && user.fullName}</span>
            <span className="block truncate text-sm font-medium">
              {user && user.email}
            </span>
            <span className="block truncate text-sm font-medium flex">
              <div className="bg-red-300 rounded-full px-2 py-1">
                {user && user.userType}
              </div>
              <div />
            </span>
          </DropdownHeader>
          <DropdownItem onClick={handleLogoutButtonClicked}>
            Sign out
          </DropdownItem>
        </Dropdown>
      </div>
    </Navbar>
  );
};

export default AdminNavBar;
